import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 font-heading">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/booking-terms" className="hover:text-accent transition-colors">Booking Terms</Link></li>
              {/* <li><Link to="/consultant-terms" className="hover:text-accent transition-colors">Consultant Terms</Link></li> */}
              <li><Link to="/privacy-policy" className="hover:text-accent transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 font-heading">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/register" className="hover:text-accent transition-colors">Consultants - Register With Us</Link></li>
              {/* <li><Link to="/manage" className="hover:text-accent transition-colors">Consultants - Manage Your Subscription</Link></li> */}
              {/* <li><Link to="/terms" className="hover:text-accent transition-colors">Membership Terms & Conditions</Link></li> */}
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-white/20 text-center">
          <p>© {new Date().getFullYear()} DNTLHRO LTD t/a Dental Hero. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
